// @noflow
import { createContext } from 'react';

const QUOTE_DEFAULT_VALUES = {
  applyUrl: '/',
  setApplyUrl: () => {}
};

const SoftQuoteContext = createContext(QUOTE_DEFAULT_VALUES);

export default SoftQuoteContext;
